module.exports = __webpack_public_path__ + "img/warning_modal_round.15ed3708.png";